<!--when updating the @gea/digital-ui-lib version, also update the html here -->
@if (!this.config.visibleFor || this.config.visibleFor(this.rowData)) {
  <div class="context-menu-wrapper" [ngClass]="{ 'index-up': open }">
    <geaui-icon-v3
      class="menu-dots"
      [clickable]="true"
      (click)="handleTriggerClick($event); op.toggle($event)"
      (mousedown)="$event.stopPropagation()"
      (mouseup)="$event.stopPropagation()"
      file="16px_menu-dots"
      color="black"
      colorProp="both"></geaui-icon-v3>

    <p-popover class="context-menu-popover" #op (onShow)="handleOnShow()" (onHide)="open = false" styleClass="popover-wrapper">
      <div class="menu-container">
        @for (item of config.items; track item) {
          <div
            class="menu-item"
            [pTooltip]="item?.disabledTranslationKey ?? 'X.INFO.NO_ACCESS.RIGHT_MISSING' | translate"
            [tooltipDisabled]="!isItemDisabled(item.action)"
            [ngClass]="{ disabledMenuItem: isItemDisabled(item.action) }"
            (dblclick)="$event.stopPropagation()"
            (click)="handleItemClick(item.action, $event)"
            tooltipPosition="left">
            <geaui-icon-v3
              [fileSize]="16"
              [file]="item.icon"
              [color]="isItemDisabled(item.action) ? 'grey' : 'black'"></geaui-icon-v3>
            <span>{{ item.text | translate }}</span>
          </div>
        }
      </div>
    </p-popover>
  </div>
}
